// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Break, O God, their teeth in their mouths;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;smash the fangs of these lions, O Lord.<br> </p> </div></div>";
// Exports
module.exports = code;